module.exports = __webpack_public_path__ + "static/img/energy_badge2x.86976818.png";